import { getShipBranchWarehouses, LoadShipBranchWarehouseParameter, ShipBranchWarehousesResult } from "@gtsanders/Services/ShipmentBranchWarehouseService";
import { HandlerWithResult } from "@gtsanders/Store/GTSState";
import {  createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";


type HandlerType = HandlerWithResult<LoadShipBranchWarehouseParameter, ShipBranchWarehousesResult>;


export const DispatchBeginLoadShipBranchWarehouses: HandlerType = async props => {
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/BeginLoadShipBranchWarehouses",
    });
};


export const RequestDataFromApi: HandlerType = async props => {
    props.result = {
        apiParameter: { },
        apiResult: [],
        shipBranchWarehouses: [],
        isLoading: true,
        shipBranchWarehousesLoaded: false,
        selectedWarehouse: { SelectedWarehouse: "", SelectedWarehouseDesc: "" },
    };
    props.result.apiResult = await getShipBranchWarehouses();
    props.result.apiResult = props.result.apiResult.sort((a, b) => (a?.Description ?? "").localeCompare(b?.Description ?? ""))
};

export const DispatchCompleteLoadShipBranchWarehouses: HandlerType = async  props => {
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/CompleteLoadShipBranchWarehouses",
        result: props.result,
    });
};

export const CleanupShipBranchWarehousesData : HandlerType = async props => {   
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/CleanupShipBranchWarehousesData",
    })
}

export const chain = [
    DispatchBeginLoadShipBranchWarehouses,
    RequestDataFromApi,
    DispatchCompleteLoadShipBranchWarehouses,
    CleanupShipBranchWarehousesData
];

const loadShipBranchWarehouses = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "LoadShipBranchWarehouses",
);
export default loadShipBranchWarehouses;
